import baseAPI from "@/http";

const router = "api/territorio-municipio";

export const territoriosMunicipioAPI = {
  listByTerritorio: (territorioId) =>
    baseAPI.get(
      `${router}/obter-territorio-municipio-por-territorio/${territorioId}`
    ),
};
